import { Button, ContentLayout, Tile } from "@2u-landing-pages/components";
import { formatCurrency } from "@2u-landing-pages/utils";
import EventClient from "@2u-landing-pages/utils/event-client";
import { Body, ButtonGroup, Container, Heading } from "@red-digital/bricks";
import cn from "classnames";
import React from "react";
import { CustomCSSProperties, DetailCalloutProps } from "./DetailCallout.types";

import styles from "./DetailCallout.module.scss";

export const DetailCallout: React.FC<DetailCalloutProps> = ({
  background_color,
  main_content,
  items,
  buttons,
  footnote,
  footnote_background_color,
  footnote_text_color,
  className,
  phoneNumber,
  tuitionCost,
  tuition_color,
  display_tuition_cost,
}) => {
  const style: CustomCSSProperties = {};

  if (background_color) style["--bg-color"] = `var(${background_color})`;
  if (tuition_color) style["--tuition-color"] = `var(${tuition_color})`;
  if (footnote_background_color) style["--footnote-bg-color"] = `var(${footnote_background_color})`;
  if (footnote_text_color) style["--footnote-color"] = `var(${footnote_text_color})`;

  const handlePhoneNumberClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const target = event.target as HTMLAnchorElement;
    EventClient.elementClicked({
      webElement: {
        elementType: "Landing Page",
        htmlId: window.location.href,
        location: "Detail Callout",
        position: "footnote",
        text: target?.innerText || "",
      },
    });
  };

  return (
    <div className={cn(className, styles.detailCallout)} style={style}>
      <ContentLayout
        className={styles.heading}
        content={main_content}
        heading={{
          variant: "heading-xl",
        }}
      />
      <Container flex>
        {items?.map((item, index) => {
          if (!item) return null;
          return (
            <Tile
              key={index}
              className={styles.tile}
              content={item}
              padded
              heading={{ variant: "heading-lg" }}
              body={{ variant: "body-sm" }}
              mobileOrientation="vertical"
              desktopOrientation="vertical"
            />
          );
        })}
      </Container>
      {tuitionCost && display_tuition_cost && (
        <Container flex justifyContent="center" className={styles.tuition}>
          <Heading variant="heading-md" type="h4" className={styles.tuitionLabel}>
            Total cost
          </Heading>
          <div>
            <Heading variant="heading-2xl" type="h4">
              US{formatCurrency(tuitionCost)}
              <sup className={styles.tuitionAsterisk}>*</sup>
            </Heading>
            <Body variant="caption-md" className={styles.tuitionLegal}>
              *Tuition subject to change
            </Body>
          </div>
        </Container>
      )}
      {buttons && buttons?.length > 0 && (
        <ButtonGroup placement="center">
          {buttons.map((button) => (
            <Button location="Detail Callout" key={button?.sys.id} {...button?.fields}>
              {button?.fields.label}
            </Button>
          ))}
        </ButtonGroup>
      )}
      {footnote ? (
        <Body variant="body-sm" className={styles.footnote}>
          {footnote}
          <a onClick={handlePhoneNumberClick} href={`tel:${phoneNumber}`}>
            {phoneNumber}
          </a>
        </Body>
      ) : (
        <>
          {/* empty div to hold space for gap */}
          <div />
        </>
      )}
    </div>
  );
};
